import * as Constants from '../constant/Constants';
import { gql, GraphQLClient } from 'graphql-request';
import Storage from './Storage';

async function requestMiddleware(request) {
  let accessToken =  Storage.getLocalAccessToken();
  if (accessToken === null) accessToken = Storage.getLocalAppToken();
  if (request.headers.Authorization !== undefined) accessToken = request.headers.Authorization
  return {
    ...request, 
    headers: {
      ...request.headers,
      Authorization: "Bearer " + accessToken
    }
  }
}

async function responseMiddleware(response) {
  if (response.response?.errors && response.response?.data === null) {
    const err = JSON.parse(JSON.stringify(response)).response.errors[0];
    if (err.extensions.code === 'UNAUTHENTICATED') {
      const token = Storage.getLocalRefreshToken();
      const query = gql`
      mutation RefreshToken {
        RefreshTokenUser {
          refreshToken {
            token
          }
          accessToken {
            token
          }
        }
      }
      `

      const headers = {
        headers: {
          Authorization: 'Bearer ' + token
        }
      }

      const ref = new GraphQLClient(Constants.customerServiceV2, headers).request(query);
      ref.then(result => {
        const accessToken = result.accessToken.token;
        const refreshToken = result.refreshToken.token;
        Storage.updateLocalAccessToken(accessToken);
        Storage.updateLocalRefreshToken(refreshToken)
      }).catch(errors => {
        console.log("Refresh token api was wrong!");
        Storage.removeAccessToken();
        Storage.removeRefreshToken();
        window.location = '/signin';
      })

    }
  }
}

export const NonTokenGraphql = new GraphQLClient(Constants.customerServiceV2);

export const ServiceGraphql = new GraphQLClient(Constants.customerServiceV2, {
  requestMiddleware: requestMiddleware,
  responseMiddleware: responseMiddleware
})